import { ConciergeGeneralSettingsParser } from "@redotech/redo-model/concierge-settings/general";
import * as z from "zod/v4";

export const getConciergeGeneralSettings = {
  name: "getConciergeGeneralSettings" as const,
  input: z.null(),
  output: z.object({ settings: ConciergeGeneralSettingsParser.optional() }),
};
